import { render, staticRenderFns } from "./HowToContactUs.vue?vue&type=template&id=9a6ca1f4&scoped=true"
import script from "./HowToContactUs.vue?vue&type=script&lang=js"
export * from "./HowToContactUs.vue?vue&type=script&lang=js"
import style0 from "./HowToContactUs.vue?vue&type=style&index=0&id=9a6ca1f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a6ca1f4",
  null
  
)

export default component.exports